module.exports = __webpack_public_path__ + "img/rule-top@2x.590ff98c.png";